'use client';

import
  dynamic
from 'next/dynamic';

import {
  useScrollReveal
} from '@/app/hooks/use-scroll-reveal';

const LottiePlayer = dynamic(() => import('@repo/ui/lottie-player'), {
  ssr: false
});

interface FeatureCardProps {
  title: string
  description: string
  animation: string
}

export default function FeatureCard({
  title, description, animation
}: FeatureCardProps) {

  const {
    ref, isVisible
  } = useScrollReveal<HTMLDivElement>();

  return (
    <div
      ref={ref}
      className={`flex items-start gap-5 transition-all duration-500 ${ isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4' }`}
    >
      <div className="flex-shrink-0 w-24 h-24">
        {isVisible && <LottiePlayer animationPath={animation} className="w-full h-full" />}
      </div>
      <div>
        <h3 className="text-lg font-bold text-[#0a1628] dark:text-white mb-2">{title}</h3>
        <p className="text-gray-500 dark:text-gray-400 text-sm leading-relaxed">{description}</p>
      </div>
    </div>
  );
}
